(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
var $3d28d7f1aac198f5$exports = {};

$parcel$export($3d28d7f1aac198f5$exports, "Game", function () { return $3d28d7f1aac198f5$export$985739bfa5723e08; });
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}



"use strict";
var $3d28d7f1aac198f5$export$985739bfa5723e08 = /*#__PURE__*/ function() {
    function Game() {
        var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.initialState = initialState;
        this.score = 0;
        this.state = (0, $227c6742e0ff6f82$export$71511d61b312f219)(this.initialState);
        this.status = "idle";
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "moveLeft",
            value: function moveLeft() {
                var _this = this, _loop = function(i) {
                    var row = _this.state[i].filter(function(number) {
                        return number !== 0;
                    });
                    for(var n = 1; n < row.length; n++)if (row[n] === row[n - 1]) {
                        row[n - 1] *= 2;
                        delete row[n];
                        _this.score += row[n - 1];
                    }
                    var newRow = row.filter(function(number) {
                        return number !== undefined;
                    });
                    for(var j = newRow.length; j < 4; j++)newRow.push(0);
                    newState[i] = newRow;
                };
                var newState = [];
                var canMove = false;
                for(var i = 3; i >= 0; i--)_loop(i);
                for(var i1 = 0; i1 <= 3; i1++){
                    for(var n = 0; n <= 3; n++)if (newState[i1][n] !== this.state[i1][n]) canMove = true;
                }
                if (canMove) {
                    this.state = newState;
                    this.addCell();
                }
                this.checkLose();
                this.checkWin();
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var _this = this, _loop = function(i) {
                    var row = _this.state[i].filter(function(number) {
                        return number !== 0;
                    });
                    for(var n = row.length - 1; n >= 0; n--)if (row[n] === row[n - 1]) {
                        row[n] *= 2;
                        row[n - 1] = 0;
                        _this.score += row[n];
                    }
                    var newRow = row.filter(function(number) {
                        return number !== 0;
                    });
                    for(var j = newRow.length; j < 4; j++)newRow.unshift(0);
                    newState[i] = newRow;
                };
                var newState = [];
                var canMove = false;
                for(var i = 3; i >= 0; i--)_loop(i);
                for(var i1 = 0; i1 <= 3; i1++){
                    for(var n = 0; n <= 3; n++)if (newState[i1][n] !== this.state[i1][n]) canMove = true;
                }
                if (canMove) {
                    this.state = newState;
                    this.addCell();
                }
                this.checkLose();
                this.checkWin();
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                this.state = this.turnTable(this.state);
                this.moveLeft();
                this.state = this.turnTable(this.state);
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                this.state = this.turnTable(this.state);
                this.moveRight();
                this.state = this.turnTable(this.state);
            }
        },
        {
            /**
   * @returns {number}
   */ key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            /**
   * @returns {number[][]}
   */ key: "getState",
            value: function getState() {
                return this.state;
            }
        },
        {
            /**
   * Returns the current game status.
@@ -50,19 +157,101 @@ class Game {
   * `win` - the game is won;
   * `lose` - the game is lost
   */ key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            /**
   * Starts the game.
   */ key: "start",
            value: function start() {
                this.status = "playing";
                this.addCell();
                this.addCell();
            }
        },
        {
            /**
   * Resets the game.
   */ key: "restart",
            value: function restart() {
                this.status = "idle";
                this.state = [
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ]
                ];
                this.score = 0;
            }
        },
        {
            key: "addCell",
            value: function addCell() {
                var initial = Math.random() > 0.1 ? 2 : 4;
                var count = 0;
                do {
                    var row = Math.round(Math.random() * 3);
                    var column = Math.round(Math.random() * 3);
                    if (this.state[row][column] === 0) {
                        this.state[row][column] = initial;
                        count++;
                    }
                }while (count < 1);
            }
        },
        {
            key: "turnTable",
            value: function turnTable(table) {
                var newTable = [];
                for(var i = 0; i <= 3; i++){
                    var newRow = [
                        table[0][i],
                        table[1][i],
                        table[2][i],
                        table[3][i]
                    ];
                    newTable.push(newRow);
                }
                return newTable;
            }
        },
        {
            key: "checkWin",
            value: function checkWin() {
                for(var i = 0; i <= 3; i++){
                    for(var n = 0; n <= 3; n++)if (this.state[i][n] === 2048) this.status = "win";
                }
            }
        },
        {
            key: "checkLose",
            value: function checkLose() {
                for(var i = 0; i < 4; i++)for(var j = 0; j < 4; j++){
                    if (this.state[i][j] === 0) return;
                    if (i < 3 && this.state[i][j] === this.state[i + 1][j] || j < 3 && this.state[i][j] === this.state[i][j + 1]) return;
                }
                this.status = "lose";
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$export$985739bfa5723e08;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
var $197cd56b15c33885$var$controls = document.querySelector(".controls");
var $197cd56b15c33885$var$score = document.querySelector(".game-score");
var $197cd56b15c33885$var$buttonStart = document.querySelector(".start");
var $197cd56b15c33885$var$tbody = document.querySelector("tbody");
var $197cd56b15c33885$var$lose = document.querySelector(".message-lose");
var $197cd56b15c33885$var$win = document.querySelector(".message-win");
var $197cd56b15c33885$var$start = document.querySelector(".message-start");
var $197cd56b15c33885$var$buttonRestart = document.createElement("button");
$197cd56b15c33885$var$buttonRestart.classList.add("restart");
$197cd56b15c33885$var$buttonRestart.classList.add("button");
$197cd56b15c33885$var$buttonRestart.textContent = "Restart";
$197cd56b15c33885$var$buttonStart.addEventListener("click", function() {
    $197cd56b15c33885$var$game.start();
    $197cd56b15c33885$var$start.classList.add("hidden");
    $197cd56b15c33885$var$updateBoard();
    $197cd56b15c33885$var$buttonStart.remove();
    $197cd56b15c33885$var$controls.append($197cd56b15c33885$var$buttonRestart);
});
$197cd56b15c33885$var$buttonRestart.addEventListener("click", function() {
    $197cd56b15c33885$var$game.restart();
    $197cd56b15c33885$var$game.start();
    $197cd56b15c33885$var$updateBoard();
    $197cd56b15c33885$var$win.classList.add("hidden");
    $197cd56b15c33885$var$lose.classList.add("hidden");
});
document.addEventListener("keydown", function(e) {
    if ($197cd56b15c33885$var$game.status === "playing") {
        if (e.key === "ArrowLeft") $197cd56b15c33885$var$game.moveLeft();
        if (e.key === "ArrowRight") $197cd56b15c33885$var$game.moveRight();
        if (e.key === "ArrowUp") $197cd56b15c33885$var$game.moveUp();
        if (e.key === "ArrowDown") $197cd56b15c33885$var$game.moveDown();
        if ($197cd56b15c33885$var$buttonStart) {
            $197cd56b15c33885$var$buttonStart.remove();
            $197cd56b15c33885$var$controls.append($197cd56b15c33885$var$buttonRestart);
        }
        if ($197cd56b15c33885$var$game.status === "win") $197cd56b15c33885$var$win.classList.remove("hidden");
        if ($197cd56b15c33885$var$game.status === "lose") $197cd56b15c33885$var$lose.classList.remove("hidden");
        $197cd56b15c33885$var$updateBoard();
    }
});
function $197cd56b15c33885$var$updateBoard() {
    $197cd56b15c33885$var$score.textContent = $197cd56b15c33885$var$game.getScore();
    var rows = (0, $227c6742e0ff6f82$export$71511d61b312f219)($197cd56b15c33885$var$tbody.querySelectorAll(".field-row"));
    for(var i = 0; i < 4; i++)for(var j = 0; j < 4; j++){
        var cells = (0, $227c6742e0ff6f82$export$71511d61b312f219)(rows[i].querySelectorAll(".field-cell"));
        if ($197cd56b15c33885$var$game.getState()[i][j] === 0) {
            cells[j].textContent = null;
            cells[j].className = "field-cell";
        }
        if ($197cd56b15c33885$var$game.getState()[i][j] !== 0) {
            cells[j].textContent = $197cd56b15c33885$var$game.getState()[i][j];
            cells[j].className = "field-cell";
            cells[j].classList.add("field-cell--" + $197cd56b15c33885$var$game.getState()[i][j]);
        }
    }
}

})();
//# sourceMappingURL=index.cfeeaad3.js.map
